import Gallery from "../Component/Gallery/Gallery";
import Info from "../Component/Info/Info";
import Plan from "../Component/Plan/Plan";

function Profile() {
    return (
        <div>
            <Info />
            <Gallery />
            <Plan />
        </div>
    )
}
export default Profile;